
////////////////////////////
// DATA FOR REQUEST MOVISTAR
import config from "../../../config/config";

export const buildDataMovistar = (data:any,UF:any)=>{ 

    let {
        paymentRef,
        invoiceType,
        isRefNumber,
        comerce,
        referen,
        novum, 
        typeConsult
    } = data;

    return ({
        "consulta": [
            {
                "parametro": "paymentRef",
                "value": paymentRef
            },
            {
                "parametro": "invoiceType",
                "value": invoiceType
            },
            {
                "parametro": "isRefNumber",
                "value": isRefNumber
            },
            {
                "parametro": "comerce",
                "value": comerce
            },
            {
                "parametro": "referen",
                "value": referen ? referen : ""
            },
            {
                "parametro": "novum",
                "value": novum ? novum : ""
            },
        ],

        "dominio": `${config.REACT_APP_MOVISTAR_DOMINIO_RECAUDO}`,
        "tipoConsulta": typeConsult ? typeConsult : 'online',
        "ultraFacturas":UF,
        "shoppingCartId": sessionStorage.getItem('shoppingCartId') ? sessionStorage.getItem('shoppingCartId'): null
    })

}

export const recolectIdInvoicesActives = (filial:number, invoices:any)=>{
    if(filial === 1) return [...invoices].map((inv:any)=> inv['identificacionEmpresa'].substring(0,10))
    if(filial === 2) return [...invoices].map((inv:any)=> inv['facturaId'])
    if(filial === 3) return [
        ...[...invoices].map((inv:any)=> inv['telefono']),
        ...[...invoices].map((inv:any)=> inv['facturaId'])
    ]
}